import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DeezerEmbedComponent } from './deezer-embed.component';
import { PlayerModeService } from './player-mode.service';

/**
 * Plays one song. In Deezer mode (default) a button opens Deezer's embedded player inline (only one is open at a
 * time); in preview mode it shows the 30-second clip.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-track-player',
  imports: [DeezerEmbedComponent],
  template: `
    @if (player.mode() === 'deezer') {
      @if (open()) {
      <app-deezer-embed kind="track" [id]="trackId()" />
      <button type="button" class="link-btn" (click)="player.toggleActive(key())">Close player</button>
      } @else {
      <button type="button" class="play-full" (click)="player.toggleActive(key())">&#9654; Play full song</button>
      }
    } @else if (previewUrl()) {
    <audio controls preload="none" [src]="previewUrl()"></audio>
    } @else {
    <em class="muted">No preview available</em>
    }
  `,
  styles: [`
    :host { display: block; }
    audio { width: 100%; height: 32px; }
    .play-full { font: inherit; font-size: 0.8rem; padding: 4px 12px; border: 1px solid #673ab7; border-radius: 14px;
      background: #fff; color: #673ab7; cursor: pointer; }
    .play-full:hover { background: rgba(103, 58, 183, 0.08); }
    .link-btn { font: inherit; font-size: 0.75rem; border: none; background: none; color: #666; cursor: pointer; padding: 2px 0; }
    .link-btn:hover { text-decoration: underline; }
    .muted { font-size: 0.8rem; color: #999; }
  `]
})
export class TrackPlayerComponent {
  protected player = inject(PlayerModeService);

  trackId = input.required<string | number>();
  previewUrl = input<string | null | undefined>(null);

  key = computed(() => `track:${this.trackId()}`);
  open = computed(() => this.player.activeKey() === this.key());
}
